var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusBordered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 28,
    rx: 5,
    stroke: "#1890FF",
    strokeDasharray: "3 3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 6.625,
    y: 6.25,
    width: 18.75,
    height: 17.5,
    fill: "#1890FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5492 8.84766H15.4505C15.3529 8.84766 15.3041 8.89323 15.3041 8.98437V14.3506H9.84766C9.75 14.3506 9.70117 14.3962 9.70117 14.4873V15.5127C9.70117 15.6038 9.75 15.6494 9.84766 15.6494H15.3041V21.0156C15.3041 21.1068 15.3529 21.1523 15.4505 21.1523H16.5492C16.6468 21.1523 16.6957 21.1068 16.6957 21.0156V15.6494H22.1523C22.25 15.6494 22.2988 15.6038 22.2988 15.5127V14.4873C22.2988 14.3962 22.25 14.3506 22.1523 14.3506H16.6957V8.98437C16.6957 8.89323 16.6468 8.84766 16.5492 8.84766Z",
    fill: "#1890FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBordered);
export default __webpack_public_path__ + "static/media/plus-bordered.473fd26bcf1e4ac452d56848f89680a8.svg";
export { ForwardRef as ReactComponent };